import React from 'react';
import { Section } from './Section';
import { Zap } from 'lucide-react';
export function Mechanism() {
  return <Section data-id="element-119">
      <div className="text-center mb-12" data-id="element-120">
        <div className="inline-flex items-center justify-center p-4 bg-brand-blue/10 rounded-full mb-6" data-id="element-121">
          <Zap className="w-12 h-12 text-brand-blue" data-id="element-122" />
        </div>
        <h2 className="font-display font-bold text-3xl md:text-5xl uppercase tracking-tight" data-id="element-123">
          Presentamos el{' '}
          <span className="text-brand-blue" data-id="element-124">
            Aislamiento Sensorial Controlado (ASC)
          </span>
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-125">
        <p data-id="element-126">
          A diferencia de todo lo anterior, el ASC no busca que sientas "menos",
          sino que enseña a tu cerebro a procesar niveles masivos de placer sin
          entrar en pánico.
        </p>
        <p data-id="element-127">
          Es como recalibrar el termostato de una caldera: hoy, tu sistema se
          apaga a los 30 grados; con el Protocolo 22, lo programaremos para que
          siga funcionando a los 100 grados sin disparar la alarma.
        </p>
        <p className="font-bold text-white text-xl md:text-2xl text-center mt-8 py-6 border-y border-brand-gray/30" data-id="element-128">
          Es un entrenamiento de 22 días diseñado para actualizar el software de
          tu respuesta biológica.
        </p>
      </div>
    </Section>;
}